import {fetchWithMessages} from "./fetchWithMessages";

export const loadEntityFromBackend = async (
  endpoint,
  entityId,
  projectId,
  existingEntity,
  changeNewEntityEditingAction,
  changeExistingEntityEditingAction,
  options
) => {
  const {notFoundAction, silentFailIfNotFound, forceReload} = {
    notFoundAction: undefined,
    silentFailIfNotFound: false,
    forceReload: false,
    ...options,
  };

  if (!existingEntity || existingEntity._id !== entityId || forceReload) {
    if (entityId === "new") {
      changeNewEntityEditingAction();
    } else {
      try {
        const data = await fetchWithMessages(
          projectId ? `projects/${projectId}/${endpoint}/${entityId}` : `${endpoint}/${entityId}`,
          {method: "GET"},
          {statusMessages: silentFailIfNotFound ? {403: null, 404: null} : undefined}
        );
        await changeExistingEntityEditingAction(data);
        return data?._id;
      } catch {
        notFoundAction && (await notFoundAction());
      }
    }
  }
};
